import React, { useState, useEffect, useCallback } from "react";
import axiosInstance from "../utils/axiosInstance";

const S = `
@keyframes mavFade{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}
@keyframes mavPop{0%{opacity:0;transform:scale(.93)}60%{transform:scale(1.02)}100%{opacity:1;transform:scale(1)}}
@keyframes mavSpin{to{transform:rotate(360deg)}}
.mav,.mav *{box-sizing:border-box;margin:0;padding:0;}
.mav{font-family:'Nunito Sans',-apple-system,BlinkMacSystemFont,sans-serif;color:#0d1b2a;animation:mavFade .35s ease;}
.mav-hdr{display:flex;align-items:flex-start;justify-content:space-between;flex-wrap:wrap;gap:12px;margin-bottom:20px;}
.mav-hdr h2{font-size:clamp(1.05rem,2.5vw,1.3rem);font-weight:800;color:#0047AB;display:flex;align-items:center;gap:8px;}
.mav-hdr p{font-size:.8rem;color:#64748b;margin-top:3px;}
.mav-btn{display:inline-flex;align-items:center;gap:6px;padding:8px 15px;border-radius:7px;border:none;font-weight:700;font-size:.81rem;cursor:pointer;transition:all .17s;font-family:inherit;}
.mav-bp{background:#0047AB;color:#fff;}.mav-bp:hover{background:#003a94;}
.mav-bs{background:#20603D;color:#fff;}.mav-bs:hover{background:#174f32;}
.mav-bd{background:#c0392b;color:#fff;}.mav-bd:hover{background:#a93226;}
.mav-bo{background:#fff;color:#0047AB;border:1.5px solid #0047AB;}.mav-bo:hover{background:#f0f6ff;}
.mav-btn:disabled{opacity:.4;cursor:not-allowed;}
.mav-stats{display:grid;grid-template-columns:repeat(auto-fit,minmax(120px,1fr));gap:10px;margin-bottom:18px;}
.mav-sbox{background:#fff;border:1px solid #e2e8f0;border-top:3px solid #e2e8f0;border-radius:9px;padding:13px 10px;text-align:center;}
.mav-snum{font-size:1.6rem;font-weight:800;line-height:1;}
.mav-slbl{font-size:.63rem;font-weight:700;text-transform:uppercase;letter-spacing:.06em;color:#64748b;margin-top:3px;}
.mav-card{background:#fff;border:1px solid #e2e8f0;border-radius:10px;overflow:hidden;box-shadow:0 1px 4px rgba(0,0,0,.06);margin-bottom:16px;}
.mav-ch{padding:12px 16px;background:#f8fafc;border-bottom:1px solid #e2e8f0;display:flex;align-items:center;gap:8px;font-weight:700;font-size:.88rem;color:#1e293b;flex-wrap:wrap;}
.mav-bar{display:flex;gap:10px;flex-wrap:wrap;padding:12px 16px;border-bottom:1px solid #e2e8f0;align-items:center;}
.mav-srch{display:flex;align-items:center;gap:7px;padding:0 11px;background:#fff;border:1.5px solid #e2e8f0;border-radius:7px;height:35px;flex:1;min-width:160px;}
.mav-srch input{border:none;outline:none;font-size:.82rem;width:100%;font-family:inherit;color:#111;}
.mav-srch input::placeholder{color:#94a3b8;}
.mav-sel{padding:7px 10px;border:1.5px solid #e2e8f0;border-radius:7px;font-size:.81rem;font-family:inherit;color:#374151;background:#fff;cursor:pointer;outline:none;}
.mav-tw{overflow-x:auto;}
.mav-tbl{width:100%;border-collapse:collapse;font-size:.81rem;}
.mav-tbl th{background:#f0f4f8;padding:9px 12px;text-align:left;font-size:.67rem;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.06em;white-space:nowrap;border-bottom:1px solid #e2e8f0;}
.mav-tbl td{padding:9px 12px;border-bottom:1px solid #f1f5f9;vertical-align:middle;}
.mav-tbl tr:last-child td{border-bottom:none;}
.mav-tbl tbody tr:hover{background:#f8faff;}
.mav-badge{display:inline-flex;align-items:center;gap:4px;padding:3px 9px;border-radius:20px;font-size:.69rem;font-weight:700;}
.mav-sub{background:rgba(0,71,171,.1);color:#0047AB;}
.mav-app{background:rgba(32,96,61,.12);color:#20603D;}
.mav-ret{background:rgba(192,57,43,.1);color:#c0392b;}
.mav-dft{background:rgba(100,116,139,.1);color:#64748b;}
.mav-prog{height:6px;background:#e2e8f0;border-radius:10px;overflow:hidden;margin-top:4px;}
.mav-progf{height:100%;background:linear-gradient(90deg,#20603D,#4ade80);border-radius:10px;transition:width .4s;}
.mav-ov{position:fixed;inset:0;background:rgba(0,0,0,.52);backdrop-filter:blur(4px);z-index:4000;display:flex;align-items:center;justify-content:center;padding:16px;animation:mavFade .2s ease;}
.mav-modal{background:#fff;border:1px solid #e2e8f0;border-radius:12px;width:100%;max-width:680px;max-height:90vh;overflow-y:auto;animation:mavPop .25s ease;box-shadow:0 16px 48px rgba(0,0,0,.14);}
.mav-mh{padding:15px 20px;background:#0047AB;color:#fff;display:flex;align-items:center;justify-content:space-between;gap:12px;position:sticky;top:0;z-index:10;border-radius:12px 12px 0 0;}
.mav-mh h3{font-size:1rem;font-weight:800;margin:0;display:flex;align-items:center;gap:8px;}
.mav-mx{width:30px;height:30px;border-radius:6px;border:1px solid rgba(255,255,255,.3);background:rgba(255,255,255,.12);color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:.9rem;}
.mav-mx:hover{background:rgba(255,255,255,.25);}
.mav-mb{padding:18px 20px;}
.mav-mf{display:flex;gap:8px;flex-wrap:wrap;align-items:center;padding:12px 16px;background:#f8fafc;border-top:1px solid #e2e8f0;border-radius:0 0 12px 12px;}
.mav-sg{display:grid;grid-template-columns:repeat(auto-fit,minmax(110px,1fr));gap:10px;margin-bottom:16px;}
.mav-sb{background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:11px;text-align:center;}
.mav-sbn{font-size:1.35rem;font-weight:800;line-height:1;}
.mav-sbl{font-size:.61rem;font-weight:700;text-transform:uppercase;letter-spacing:.06em;color:#64748b;margin-top:3px;}
.mav-txt{width:100%;padding:9px 12px;border:1.5px solid #e2e8f0;border-radius:7px;font-size:.84rem;font-family:inherit;outline:none;resize:vertical;min-height:76px;}
.mav-txt:focus{border-color:#0047AB;}
.mav-banner{display:flex;align-items:center;gap:9px;padding:10px 14px;border-radius:8px;font-weight:600;font-size:.82rem;margin-bottom:14px;border:1.5px solid;}
.mav-ok{background:rgba(32,96,61,.09);border-color:rgba(32,96,61,.3);color:#20603D;}
.mav-warn{background:rgba(224,123,0,.08);border-color:rgba(224,123,0,.3);color:#e07b00;}
.mav-info{background:rgba(0,71,171,.07);border-color:rgba(0,71,171,.25);color:#0047AB;}
.mav-empty{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:52px 20px;gap:10px;color:#94a3b8;text-align:center;}
.mav-spin{width:26px;height:26px;border:3px solid rgba(0,71,171,.15);border-top-color:#0047AB;border-radius:50%;animation:mavSpin .7s linear infinite;margin:40px auto;}
@media(max-width:640px){.mav-stats{grid-template-columns:repeat(2,1fr);}.mav-sg{grid-template-columns:repeat(2,1fr);}}
`;

const fmtDate = (d) => {
  if (!d) return "—";
  try { return new Date(d).toLocaleDateString("rw-RW", { year: "numeric", month: "long", day: "numeric" }); }
  catch { return String(d); }
};

const Badge = ({ status }) => {
  const m = {
    SUBMITTED: { cls: "mav-sub", icon: "📬", label: "Yoherejwe" },
    APPROVED:  { cls: "mav-app", icon: "✅", label: "Yemejwe" },
    RETURNED:  { cls: "mav-ret", icon: "↩️", label: "Yarsubijwe" },
    SAVED:     { cls: "mav-dft", icon: "💾", label: "Byabitswe" },
    DRAFT:     { cls: "mav-dft", icon: "✏️", label: "Draft" },
  };
  const s = m[status] || m.DRAFT;
  return <span className={`mav-badge ${s.cls}`}>{s.icon} {s.label}</span>;
};

export default function MudugudAttendanceViewer() {
  const [reports, setReports]       = useState([]);
  const [loading, setLoading]       = useState(false);
  const [search, setSearch]         = useState("");
  const [filterStatus, setFilter]   = useState("all");
  const [detail, setDetail]         = useState(null);
  const [records, setRecords]       = useState([]);
  const [recLoading, setRecLoading] = useState(false);
  const [comment, setComment]       = useState("");
  const [saving, setSaving]         = useState(false);
  const [banner, setBanner]         = useState(null);

  const showBanner = (type, msg) => {
    setBanner({ type, msg });
    setTimeout(() => setBanner(null), 4000);
  };

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/mudugudu/isibo-attendance");
      setReports(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      showBanner("warn", e?.response?.data?.error || "Habaye ikosa mu gusoma raporo.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const openDetail = async (act) => {
    setDetail(act);
    setComment(act.mudugudu_comment || "");
    setRecords([]);
    setRecLoading(true);
    try {
      const res = await axiosInstance.get(`/mudugudu/isibo-attendance/${act.activity_id}/records`);
      setRecords(Array.isArray(res.data) ? res.data : []);
    } catch { setRecords([]); }
    finally { setRecLoading(false); }
  };

  const approve = async () => {
    setSaving(true);
    try {
      await axiosInstance.post("/mudugudu/isibo-attendance/approve", { activity_id: detail.activity_id, comment });
      showBanner("ok", "Raporo yemejwe neza ✓");
      setDetail(null);
      load();
    } catch (e) {
      showBanner("warn", e?.response?.data?.error || "Kubika byanze.");
    } finally { setSaving(false); }
  };

  const returnReport = async () => {
    if (!comment.trim()) { showBanner("warn", "Andika impamvu yo kusubiza raporo."); return; }
    setSaving(true);
    try {
      await axiosInstance.post("/mudugudu/isibo-attendance/return", { activity_id: detail.activity_id, comment });
      showBanner("warn", "Raporo yarsubijwe Isibo kugira ikorehe.");
      setDetail(null);
      load();
    } catch (e) {
      showBanner("warn", e?.response?.data?.error || "Kubika byanze.");
    } finally { setSaving(false); }
  };

  const exportCSV = (act, rows) => {
    const csv = [
      ["Amazina", "Status", "Marked By", "Itariki"].join(","),
      ...rows.map((r) => [
        `"${r.fullname || ""}"`,
        r.status || r.attended || "—",
        `"${r.marked_by || "—"}"`,
        fmtDate(r.created_at),
      ].join(",")),
    ].join("\n");
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
    a.download = `att-${act.activity_name}-${act.activity_date}.csv`;
    a.click();
  };

  const filtered = reports.filter((r) => {
    if (filterStatus !== "all" && r.status !== filterStatus) return false;
    if (search) {
      const q = search.toLowerCase();
      return (r.activity_name || "").toLowerCase().includes(q) ||
             (r.isibo_name || "").toLowerCase().includes(q);
    }
    return true;
  });

  const stats = {
    total:    reports.length,
    pending:  reports.filter((r) => r.status === "SUBMITTED").length,
    approved: reports.filter((r) => r.status === "APPROVED").length,
    returned: reports.filter((r) => r.status === "RETURNED").length,
    citizens: reports.reduce((s, r) => s + Number(r.total_citizens || 0), 0),
    yego:     reports.reduce((s, r) => s + Number(r.yego_count || 0), 0),
  };
  const pct = stats.citizens > 0 ? Math.round((stats.yego / stats.citizens) * 100) : 0;

  return (
    <>
      <style>{S}</style>
      <div className="mav">

        {/* Header */}
        <div className="mav-hdr">
          <div>
            <h2>📋 Raporo z'Attendance — Isibo</h2>
            <p>Gucunga raporo zoherejwe n'abasibo</p>
          </div>
          <button className="mav-btn mav-bo" onClick={load}>🔄 Vugurura</button>
        </div>

        {/* Banner */}
        {banner && (
          <div className={`mav-banner ${banner.type === "ok" ? "mav-ok" : banner.type === "warn" ? "mav-warn" : "mav-info"}`}>
            {banner.type === "ok" ? "✓" : banner.type === "warn" ? "⚠" : "ℹ"} {banner.msg}
          </div>
        )}

        {/* Stats */}
        <div className="mav-stats">
          {[
            { n: stats.total,    l: "Raporo Zose",        c: "#0047AB" },
            { n: stats.pending,  l: "Zitegerejwe",        c: "#e07b00" },
            { n: stats.approved, l: "Zemejwe",            c: "#20603D" },
            { n: stats.returned, l: "Zarsubijwe",         c: "#c0392b" },
            { n: stats.citizens, l: "Abaturage Bose",     c: "#0047AB" },
            { n: `${pct}%`,      l: "Ikigero Attendance", c: "#20603D" },
          ].map((s) => (
            <div key={s.l} className="mav-sbox" style={{ borderTopColor: s.c }}>
              <div className="mav-snum" style={{ color: s.c }}>{s.n}</div>
              <div className="mav-slbl">{s.l}</div>
            </div>
          ))}
        </div>

        {/* Table Card */}
        <div className="mav-card">
          <div className="mav-ch">
            <span>📋</span>
            Raporo Zoherejwe ({filtered.length})
          </div>

          <div className="mav-bar">
            <div className="mav-srch">
              <i className="bi bi-search" />
              <input
                placeholder="Shakisha raporo cyangwa isibo..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <select className="mav-sel" value={filterStatus} onChange={(e) => setFilter(e.target.value)}>
              <option value="all">Imiterere yose</option>
              <option value="SUBMITTED">📬 Yoherejwe</option>
              <option value="APPROVED">✅ Yemejwe</option>
              <option value="RETURNED">↩️ Yarsubijwe</option>
            </select>
          </div>

          {loading ? (
            <div className="mav-spin" />
          ) : filtered.length === 0 ? (
            <div className="mav-empty">
              <div style={{ fontSize: 48, opacity: .3 }}>📭</div>
              <div style={{ fontWeight: 700, fontSize: ".9rem", color: "#374151" }}>
                {reports.length === 0
                  ? "Nta raporo zihari — Isibo ntiyohereje na rimwe."
                  : "Nta raporo ihuye n'ishakiro ryawe."}
              </div>
              <div style={{ fontSize: ".78rem" }}>Raporo zoherejwe na Isibo zizagaragara hano.</div>
            </div>
          ) : (
            <div className="mav-tw">
              <table className="mav-tbl">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Igikorwa</th>
                    <th>Isibo</th>
                    <th>Itariki</th>
                    <th>Total</th>
                    <th>Yego</th>
                    <th>%</th>
                    <th>Imiterere</th>
                    <th>Yoherejwe</th>
                    <th>Ibikorwa</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((r, i) => {
                    const total = Number(r.total_citizens || 0);
                    const yes   = Number(r.yego_count || 0);
                    const p     = total > 0 ? Math.round((yes / total) * 100) : 0;
                    return (
                      <tr key={r.activity_id}>
                        <td style={{ color: "#94a3b8", fontSize: ".73rem" }}>{i + 1}</td>
                        <td style={{ fontWeight: 700, color: "#1e293b", maxWidth: 160, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {r.activity_name}
                        </td>
                        <td style={{ fontSize: ".78rem", color: "#475569" }}>{r.isibo_name || "—"}</td>
                        <td style={{ whiteSpace: "nowrap", fontSize: ".78rem" }}>{fmtDate(r.activity_date)}</td>
                        <td style={{ textAlign: "center", fontWeight: 700, color: "#0047AB" }}>{total}</td>
                        <td style={{ textAlign: "center", fontWeight: 700, color: "#20603D" }}>{yes}</td>
                        <td>
                          <span style={{ fontWeight: 700, color: p >= 70 ? "#20603D" : p >= 40 ? "#e07b00" : "#c0392b" }}>{p}%</span>
                          <div className="mav-prog"><div className="mav-progf" style={{ width: `${p}%` }} /></div>
                        </td>
                        <td><Badge status={r.status} /></td>
                        <td style={{ fontSize: ".73rem", color: "#64748b", whiteSpace: "nowrap" }}>{fmtDate(r.submitted_at)}</td>
                        <td>
                          <button className="mav-btn mav-bp" style={{ padding: "5px 11px", fontSize: ".73rem" }} onClick={() => openDetail(r)}>
                            👁 Reba
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Detail Modal */}
        {detail && (
          <div className="mav-ov" onClick={(e) => e.target === e.currentTarget && setDetail(null)}>
            <div className="mav-modal">
              <div className="mav-mh">
                <h3>📋 {detail.activity_name}</h3>
                <button className="mav-mx" onClick={() => setDetail(null)}>✕</button>
              </div>

              <div className="mav-mb">
                {/* meta */}
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 14, fontSize: ".8rem", color: "#64748b" }}>
                  <span>📅 {fmtDate(detail.activity_date)}</span>
                  <span>🏘 {detail.isibo_name || "—"}</span>
                  <span>🕐 {fmtDate(detail.submitted_at)}</span>
                  <Badge status={detail.status} />
                </div>

                {detail.description && (
                  <p style={{ fontSize: ".82rem", color: "#374151", marginBottom: 14, background: "#f8fafc", padding: "8px 12px", borderRadius: 7, borderLeft: "3px solid #0047AB" }}>
                    {detail.description}
                  </p>
                )}

                {/* summary boxes */}
                {(() => {
                  const total = Number(detail.total_citizens || 0);
                  const yes   = Number(detail.yego_count || 0);
                  const no    = Number(detail.oya_count || 0);
                  const p     = total > 0 ? Math.round((yes / total) * 100) : 0;
                  return (
                    <div className="mav-sg">
                      {[
                        { n: total,    l: "Abaturage Bose", c: "#0047AB" },
                        { n: yes,      l: "Yego",           c: "#20603D" },
                        { n: no,       l: "Oya",            c: "#c0392b" },
                        { n: `${p}%`,  l: "Attendance %",   c: "#e07b00" },
                      ].map((b) => (
                        <div key={b.l} className="mav-sb" style={{ borderTop: `3px solid ${b.c}` }}>
                          <div className="mav-sbn" style={{ color: b.c }}>{b.n}</div>
                          <div className="mav-sbl">{b.l}</div>
                          {b.l.includes("%") && (
                            <div className="mav-prog"><div className="mav-progf" style={{ width: b.n }} /></div>
                          )}
                        </div>
                      ))}
                    </div>
                  );
                })()}

                {/* records table */}
                <div style={{ borderRadius: 8, border: "1px solid #e2e8f0", overflow: "hidden", marginBottom: 16 }}>
                  <table className="mav-tbl">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Amazina</th>
                        <th>Attendance</th>
                        <th>Marked By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {recLoading ? (
                        <tr><td colSpan={4} style={{ padding: 20, textAlign: "center" }}>
                          <div className="mav-spin" style={{ margin: "10px auto" }} />
                        </td></tr>
                      ) : records.length === 0 ? (
                        <tr><td colSpan={4} style={{ textAlign: "center", padding: 18, color: "#94a3b8" }}>
                          Nta makuru y'abaturage
                        </td></tr>
                      ) : records.map((r, i) => {
                        const st = r.status_resolved || r.status || (r.attended === "Yego" ? "YES" : r.attended === "Oya" ? "NO" : null);
                        return (
                          <tr key={r.id || i}>
                            <td style={{ color: "#94a3b8", fontSize: ".73rem" }}>{i + 1}</td>
                            <td style={{ fontWeight: 500 }}>{r.fullname || "—"}</td>
                            <td>
                              <span style={{ fontWeight: 700, color: st === "YES" ? "#20603D" : st === "NO" ? "#c0392b" : "#94a3b8" }}>
                                {st === "YES" ? "✓ Yego" : st === "NO" ? "✗ Oya" : "—"}
                              </span>
                            </td>
                            <td style={{ fontSize: ".73rem", color: "#64748b" }}>{r.marked_by || "—"}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {/* comment input — only when pending */}
                {detail.status === "SUBMITTED" && (
                  <div style={{ marginBottom: 14 }}>
                    <label style={{ display: "block", fontSize: ".77rem", fontWeight: 700, color: "#374151", marginBottom: 5 }}>
                      Ubutumwa / Impamvu (birihwanye)
                    </label>
                    <textarea
                      className="mav-txt"
                      placeholder="Andika igitekerezo, impamvu yo gusubiza, cyangwa ibyemezo..."
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                    />
                  </div>
                )}

                {/* previous comment */}
                {detail.mudugudu_comment && (
                  <div style={{ background: "#f0f6ff", borderRadius: 7, padding: "9px 12px", marginBottom: 14, fontSize: ".8rem", color: "#0047AB", borderLeft: "3px solid #0047AB" }}>
                    <strong>Igitekerezo cyabanjirije:</strong> {detail.mudugudu_comment}
                  </div>
                )}
              </div>

              {/* action footer */}
              <div className="mav-mf">
                {detail.status === "SUBMITTED" && (
                  <>
                    <button className="mav-btn mav-bs" disabled={saving} onClick={approve}>
                      {saving ? "Birimo…" : "✅ Emeza Raporo"}
                    </button>
                    <button className="mav-btn mav-bd" disabled={saving} onClick={returnReport}>
                      {saving ? "Birimo…" : "↩️ Subiza Isibo"}
                    </button>
                  </>
                )}
                {detail.status === "APPROVED" && (
                  <span className="mav-badge mav-app" style={{ padding: "7px 13px", fontSize: ".8rem" }}>
                    ✅ Yemejwe — {fmtDate(detail.reviewed_at)}
                  </span>
                )}
                {detail.status === "RETURNED" && (
                  <span className="mav-badge mav-ret" style={{ padding: "7px 13px", fontSize: ".8rem" }}>
                    ↩️ Yarsubijwe — {fmtDate(detail.reviewed_at)}
                  </span>
                )}
                <div style={{ flex: 1 }} />
                <button className="mav-btn mav-bo" style={{ fontSize: ".73rem" }} onClick={() => exportCSV(detail, records)}>
                  📥 Excel
                </button>
                <button className="mav-btn mav-bo" style={{ fontSize: ".73rem" }} onClick={() => setDetail(null)}>
                  Funga
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
